import { Button, ButtonProps } from "@mui/material";
import cn from "classnames";

export interface Props extends ButtonProps {
  selected?: boolean;
}

export default function NavButton({
  children,
  className,
  sx = {},
  selected = false,
  ...etc
}: Props) {
  return (
    <Button
      variant="text"
      disableRipple
      disableFocusRipple
      disableTouchRipple
      className={cn(className, { selected })}
      sx={{
        ...sx,
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          background: "transparent",
        },
      }}
      {...etc}
    >
      {children}
    </Button>
  );
}
